var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultiIconVolcanobet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44922 7.43359L8.23438 3.53125C9.18359 3.00391 10.3789 3.32031 10.9062 4.23438L16.7773 14.4297C17.3398 15.3438 17.0234 16.5391 16.0742 17.1016L9.28906 21.0039C8.33984 21.5312 7.14453 21.2148 6.61719 20.3008L0.746094 10.1055C0.21875 9.19141 0.535156 7.99609 1.44922 7.43359ZM16.6367 18.0508C18.1133 17.207 18.6055 15.3086 17.7617 13.8672L12.9453 5.53516C13.0156 5.53516 13.0859 5.5 13.1562 5.5H21.0312C22.0859 5.5 23 6.41406 23 7.46875V19.2812C23 20.3711 22.0859 21.25 21.0312 21.25H13.1562C12.6641 21.25 12.207 21.1094 11.8906 20.793L16.6367 18.0508Z",
    fill: "#263130"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiIconVolcanobet);
export default ForwardRef;